import { CartSessionKeyProvider, useRegionCurrency } from '@skin-seoul/service';
import {
  CartDrawerContextProvider,
  useCartDrawer,
  ShoppingBagDrawer as ShoppingBagDrawerComponent,
  ShoppingBagButton as ShoppingBagButtonComponent,
} from '@skin-seoul/shared-components';
import type { ComponentProps } from 'react';
import { useEffect } from 'react';
import { wpBridge } from '@skin-seoul/utils';

type ShoppingBagButtonProps = Pick<ComponentProps<typeof ShoppingBagButtonComponent>, 'iconProps'>;

const ShoppingBagButton = ({ iconProps }: ShoppingBagButtonProps) => {
  const { onCartToggle } = useCartDrawer();
  const { country } = useRegionCurrency();

  return <ShoppingBagButtonComponent country={country} onClick={() => onCartToggle()} iconProps={iconProps} />;
};

const ShoppingBagDrawer = () => {
  const { currency } = useRegionCurrency();
  const { onCartClose } = useCartDrawer();
  const push = (path: string) => {
    window.location.href = path;
  };

  const handleContinueShopping = () => {
    onCartClose();
    push('/');
  };

  return <ShoppingBagDrawerComponent currency={currency} onClickContinueShopping={handleContinueShopping} />;
};

type ShoppingBagDrawerButtonProps = ShoppingBagButtonProps;

const CartDrawerWPListener = () => {
  const { onCartOpen } = useCartDrawer();

  useEffect(() => {
    const off = wpBridge.on('add-to-cart', () => {
      onCartOpen();
    });
    return off;
  }, [onCartOpen]);

  return null;
};

const CartDrawerButton = ({ iconProps }: ShoppingBagDrawerButtonProps) => {
  return (
    <CartDrawerContextProvider>
      <CartSessionKeyProvider>
        <CartDrawerWPListener />
        <ShoppingBagButton iconProps={iconProps} />
        <ShoppingBagDrawer />
      </CartSessionKeyProvider>
    </CartDrawerContextProvider>
  );
};

export const HeaderCartButton = () => {
  return <CartDrawerButton iconProps={{ color: 'generic.0' }} />;
};

export const MobileNavCartButton = () => {
  return <CartDrawerButton iconProps={{ color: 'neutral.200', strokeWidth: 0.5 }} />;
};
